import React from "react"
import { Flex, Form, Input } from "antd"

import { WidgetCard } from "@src/pages/widgetModify/ui/WidgetCard"

export const WidgetGeneralSettings = () => {
  return (
    <WidgetCard title="General settings">
      <Flex gap={16} vertical>
        <Form.Item
          id="GENERATED_ID_WIDGETGENERALSETTINGS_TSX_FORM.ITEM_VOID_1"
          label="Widget name"
          name="name"
          rules={[{ message: "Please input name", required: true }]}
        >
          <Input placeholder="Enter widget name" />
        </Form.Item>

        <Form.Item
          id="GENERATED_ID_WIDGETGENERALSETTINGS_TSX_FORM.ITEM_VOID_2"
          label="Domain URL"
          name="url"
          rules={[{ required: true, type: "url" }]}
        >
          <Input placeholder="Enter domain URL" />
        </Form.Item>
      </Flex>
    </WidgetCard>
  )
}
